<template>
  <section class="s-bg-parallax inViewport">
    <div class="s-bg-parallax__main">
      <div class="s-bg-parallax__img">
        <img
          v-if="data.introImg"
          class="s-bg-parallax__thumbnail"
          :src="data.introImg.imgSrc"
          :alt="data.introImg.alt" />
      </div>
      <div class="s-bg-parallax__conts">
        <div class="s-bg-parallax__row">
          <div class="s-bg-parallax__txt">
            <div class="s-bg-parallax__info">
              <div class="s-bg-parallax__title">
                {{ data.introTitle }}
              </div>
            </div>
            <button
              type="button"
              class="s-bg-parallax__cta"
              @click="$emit('start-wizard')">
              <span>{{ data.introButtonLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  emits: ['start-wizard'],
}
</script>
